var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoMap = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "16px",
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7A4D2BBF-81F1-4164-B3C1-1B91F0FDCFFE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.8678161,14.4864841 L11.8678161,6.35074677 L8.47701152,4.68018218 L8.47701152,12.8159195 L11.8678161,14.4864841 Z M13.5632184,14.4827606 L16.954023,12.8180362 L16.954023,4.68099237 L13.5632184,6.3457168 L13.5632184,14.4827606 Z M6.78160922,12.8209495 L6.78160922,4.68390563 L3.39080461,6.34863007 L3.39080461,14.4856739 L6.78160922,12.8209495 Z M12.7102475,4.9015295 L18.6494253,1.9856743 L18.6494253,13.8486308 L12.7089192,16.7651381 L7.63458015,14.265138 L1.6954023,17.1809932 L1.6954023,5.3180367 L7.63590841,2.40152939 L12.7102475,4.9015295 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03-Sixtbook_Profile-A",
    transform: "translate(-1439.000000, -152.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Contact-Info",
    transform: "translate(0.000000, 71.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "work-address",
    transform: "translate(1010.000000, 49.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24x24/ico_map",
    transform: "translate(428.258621, 30.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#FF5000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoMap);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_map.b1fa1488e4e4ea8a821118946fa81087.svg";